export default __webpack_public_path__ + "static/media/vlaanderen_zorg@2x.1e8162c2.png";